import { defineMessages } from 'react-intl';

export default defineMessages({
  errorWalletBalanceNotEnough: `Your {poolReserveSymbol} wallet balance is not enough`,
  caption: 'Deposit overview',
  boxDescription: 'Please submit to deposit',
  approveDescription: 'Please approve before depositing',
  valueRowTitle: 'Amount',
  newHealthFactor: 'New health factor',

  connectWallet: 'Please connect a wallet',
  connectWalletDescription:
    'We couldn’t detect a wallet. Connect a wallet to deposit and see your balance grow.',
  collateral: 'Collateral Usage',
  yes: 'Yes',
  no: 'No',
});
